import { Ban, MessageCircle, ShieldAlert } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { useI18n } from '../lib/i18n';

export type GateReason = 'no-telegram' | 'denied' | 'error';

/**
 * Экран, когда внутрь не пускают.
 *
 * Разделяем три случая: приложение открыли вне Telegram (подтвердить личность
 * нечем), Telegram ID не в белом списке (и это нормальный ответ, а не поломка),
 * и сервер не ответил. В первых двух повторять попытку бессмысленно, поэтому
 * кнопки нет — вместо неё понятное объяснение.
 */
export function GateScreen({
  reason,
  message,
  onRetry,
}: {
  reason: GateReason;
  message?: string;
  onRetry?: () => void;
}) {
  const { t } = useI18n();

  const content = {
    'no-telegram': {
      icon: <MessageCircle size={44} />,
      title: t('gate.openInTelegram'),
      hint: t('gate.openInTelegramHint'),
    },
    denied: {
      icon: <Ban size={44} />,
      title: t('gate.denied'),
      hint: t('gate.deniedHint'),
    },
    error: {
      icon: <ShieldAlert size={44} />,
      title: t('gate.authError'),
      hint: message,
    },
  }[reason];

  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-4 px-8 text-center">
      <div className="text-muted opacity-50">{content.icon}</div>
      <h1 className="text-[19px] font-semibold">{content.title}</h1>
      {content.hint && <p className="text-muted max-w-sm text-[14px]">{content.hint}</p>}
      {reason === 'error' && onRetry && (
        <Button variant="secondary" onClick={onRetry}>
          {t('app.retry')}
        </Button>
      )}
    </div>
  );
}
